export default __webpack_public_path__ + "static/media/nft1.1c6d6752.png";